module.exports = __webpack_public_path__ + "media/components/country-flag/static/it-ee9cb8838f9e0519d8831084c300a8f0.svg";